import { DefaultResponseDTO } from '../../../shared/constants';
import { registrationGet } from '../../../shared/registrationApi/api';
import { SchoolLeadsDetails } from './school-leads-details.dto';

export const getSchoolSingleLeadRequest = (leadId: string): Promise<DefaultResponseDTO<SchoolLeadsDetails>> => {
  return registrationGet<DefaultResponseDTO<SchoolLeadsDetails>>(`/lead/${leadId}`);
};
